import { render } from "./BooksView.vue?vue&type=template&id=43a9146a&scoped=true"
import script from "./BooksView.vue?vue&type=script&lang=js"
export * from "./BooksView.vue?vue&type=script&lang=js"

import "./BooksView.vue?vue&type=style&index=0&id=43a9146a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a9146a"]])

export default __exports__